module.exports = __webpack_public_path__ + "static/media/Portrait-10205.72c84cd6.jpg";